(function (Drupal, $, once) {
  Drupal.behaviors.serchResult = {
    attach: function (context) {
      "use strict";
      $(once('search-result-path', ".path-search"))
        .each(function () {
          function updateTerm() {
            var searchTerm = $(
              "#views-exposed-form-search-page-1 .js-form-type-textfield input"
            ).val();
            $(".view-header>span").text(searchTerm);
          }

          function handleSearchClear() {
            var $this = $("#views-exposed-form-search-page-1 input[type=text]");
            var search = $this.parent(".js-form-type-textfield");
            var val = $this.val();

            if (val.length > 0) {
              if (!search.children(".search-clear").length) {
                search.append(
                  '</div><button class="search-clear" type="button" title="Clear the search"><span></span></button>'
                );
              }
              if (!search.children(".autocomplete-wrapper").length) {
                search.append('<div class="autocomplete-wrapper"></div>');
              }
            } else {
              search.children(".search-clear").remove();
            }
          }

          updateTerm();

          $(document).on(
            "keyup",
            "#views-exposed-form-search-page-1 input[type=text]",
            function () {
              handleSearchClear();
            }
          );

          $(document).ajaxComplete(function () {
            updateTerm();
            handleSearchClear();
          });

          $("#views-exposed-form-search-page-1 .js-form-type-textfield").append(
            '</div><button class="search-clear" type="button" title="Clear the search"><span></span></button>'
          );

          $(document).on(
            "click",
            "#views-exposed-form-search-page-1 .search-clear",
            function (e) {
              e.preventDefault();
              $(this).closest("form").find("input[type=text]").val("").focus();
              $(this).remove();
            }
          );
        }); // once
    },
  };
}(Drupal, jQuery, once));
